<template>
    <img src="../assets/images/ai.png" @click="openAi" />
</template>

<script setup>
    import { onUnmounted } from "vue"
    import { createChat, destroyChat } from "@/components/Chat/Index.js"

    const openAi = () => {
        createChat()
    }

    onUnmounted(() => { //页面卸载时执行
        if(document.querySelector('#ChatComponent')){
            destroyChat();
        }
    })
</script>

<style scoped>
    img {
        width: 35px;
        height: auto;
        position: fixed;
        bottom: 30px;
        right: 30px;
        cursor: pointer;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        background-color: #fff;
        border-radius: 10px;
        z-index: 999;
        &:hover {
            transform: scale(1.1);
        }
    }
</style>